
import config from '../../config';
/**
 * Class to represent specific media usage. It'll grow as we allow user to select the crop area.
 *
 * @class MediaUsage
 * @property media {object} Media object
 * @property width {integer} Requested media width
 * @property height {integer} Requested media height
 */
export default class MediaUsage {
    constructor(media, width, height) {
        this.media = media;
        this.width = width;
        this.height = height;
    }

    getImgUrl() {
        return `${config.API_PUBLIC.replace(/\/+$/, '')}/image/${this.width}x${this.height}/${this.media.key}`
    }
}


// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/MediaUsage.js